import { render, staticRenderFns } from "./fbaWarehousingDetail.vue?vue&type=template&id=4d78845d&"
import script from "./fbaWarehousingDetail.vue?vue&type=script&lang=js&"
export * from "./fbaWarehousingDetail.vue?vue&type=script&lang=js&"
import style0 from "./fbaWarehousingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d78845d')) {
      api.createRecord('4d78845d', component.options)
    } else {
      api.reload('4d78845d', component.options)
    }
    module.hot.accept("./fbaWarehousingDetail.vue?vue&type=template&id=4d78845d&", function () {
      api.rerender('4d78845d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/Warehousing/fbaWarehousingDetail.vue"
export default component.exports